export default __webpack_public_path__ + "static/media/shift-leader-assesment.7b2ecce0.png";